import { render } from "./ObjectDetailView.vue?vue&type=template&id=065837de&scoped=true"
import script from "./ObjectDetailView.vue?vue&type=script&lang=js"
export * from "./ObjectDetailView.vue?vue&type=script&lang=js"

import "./ObjectDetailView.vue?vue&type=style&index=0&id=065837de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065837de"]])

export default __exports__